import { render, staticRenderFns } from "./AuctionDetailsCard.vue?vue&type=template&id=771735f4&scoped=true"
import script from "./AuctionDetailsCard.vue?vue&type=script&lang=js"
export * from "./AuctionDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./AuctionDetailsCard.vue?vue&type=style&index=0&id=771735f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771735f4",
  null
  
)

export default component.exports